import { useNavigate } from 'react-router-dom';

import { fetchBookingsList } from 'services';

import SuccessDialog from 'components/organization/dialog/success-dialog';
import DataTable from 'components/tables/data-table';
import { useAuth } from 'contexts';
import { FC, useMemo } from 'react';
import { downloadCsv } from 'services/download-csv';
import { Role } from 'types';
import { FilterOperator } from 'utils';
import { bookingDataColumns, defaultBookingColumns } from './booking-columns';

const BookingList: FC = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const initialColumns = useMemo(
    () =>
      userProfile.columnPreferences.filter(cp => cp.table === 'BOOKING').length > 0
        ? userProfile.columnPreferences
            .filter(cp => cp.table === 'BOOKING')
            .map(({ column, width }) => {
              return { field: column, width };
            })
        : defaultBookingColumns.map(c => {
            return { field: c, width: 80 };
          }),
    [userProfile.columnPreferences]
  );



  return (
    <div className="page" id="booking-list">
      <div className="page-header">
        <h1>BOOKINGS</h1>
        <div className="d-flex g-3">

          {[
            Role.ADMIN,
            Role.BILLING_ADMIN,
            Role.SENIOR_BOOKING,
            Role.BOOKING,
            Role.ADMIN_CUSTOMER,
            Role.CUSTOMER,
            Role.EXTERNAL
          ].includes(userProfile.role) && (
            <button className="btn-outline" onClick={() => navigate('/templates')}>
              TEMPLATES
            </button>
          )}
          {[
            Role.ADMIN,
            Role.BILLING_ADMIN,
            Role.SENIOR_BOOKING,
            Role.BOOKING,
            Role.GATE_BOOKING,
            Role.ADMIN_CUSTOMER,
            Role.CUSTOMER,
            Role.EXTERNAL
          ].includes(userProfile.role) && (
            <button className="btn-primary" onClick={() => navigate('/bookings/new')}>
              NEW BOOKING
            </button>
          )}
        </div>
      </div>
      <div className="flex-fill">
        <DataTable
          tableClass="t-height"
          fetchData={fetchBookingsList}
          fetchCsv={downloadCsv('bookings')}
          columns={bookingDataColumns}
          initialPage={{ pageNum: 0, pageSize: 100, sortField: 'createdDate', sortDirection: 'desc' }}
          filterByLocation
          initialColumns={initialColumns}
          initialFilters={{
            filters: [
              {
                field: 'expirationDate',
                // get the format for the "date" type input by applying the timezone offset to the ISOString() (which is in UTC).
                value: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10),
                filterOperator: FilterOperator.AFTER
              }
            ]
          }}
          enableSaveColumns="BOOKING"
          showColumnsCategorized
        />
      </div>
      <SuccessDialog />
    </div>
  );
};

export default BookingList;
